
import { defineComponent } from 'vue'
import mitt from 'mitt'

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    emitter: ReturnType<typeof mitt>
  }
}

export default defineComponent({
  data (): Record<string, unknown> {
    return {
      userName: 'Jean Gonzales',
      status: 'Product Owner',
      avatar: 'person.png',
      completedTasks: 372,
      openTasks: 11,
      notifications: 3,
      socialImages: [
        {
          img: 'socials_1.png',
          id: 1
        },
        {
          img: 'socials_2.png',
          id: 2
        },
        {
          img: 'socials_3.png',
          id: 3
        }
      ]
    }
  },

  methods: {
    makeActive (e: Event): void {
      const currentElement = e.target as HTMLElement
      const selectorName = currentElement.className
      const selectorNameActive = `${selectorName}--active`
      const currentActive: HTMLElement | null = document.querySelector(`.${selectorNameActive}`)
      if (currentActive) {
        currentActive.classList.remove(selectorNameActive)
        currentElement.classList.add(selectorNameActive)
      }
    },
    makeTasksActive (e: Event): void {
      const currentElement = e.target as HTMLElement
      if (currentElement.id === 'completed_tasks') {
        currentElement.style.cursor = 'pointer'
        currentElement.style.outline = '3px solid rgba(191, 191, 191, 0.2)'
        currentElement.style.outlineOffset = '4px'
      }
    },
    makeTasksNonActive (e: Event): void {
      (e.target as HTMLElement).style.outline = 'none'
    },
    changeTasksCounter (): void {
      if (this.openTasks as number > 0) {
        this.confirmChange()
      } else {
        const declineWindow = this.createWindow('You don\'t have any open tasks to set complete.')
        const okBtn = this.createButton('Ok')
        const btnBlock = this.createBtnBlock()
        btnBlock.appendChild(okBtn)
        declineWindow.appendChild(btnBlock)
        okBtn.onclick = function () {
          declineWindow.remove()
        }
      }
    },
    confirmChange (): void {
      const confirmWindow = this.createWindow('Are you sure you want to change the number of tasks?')
      const btnBlock = this.createBtnBlock()
      const yesBtn = this.createButton('Yep')
      const noBtn = this.createButton('Nope')
      btnBlock.appendChild(yesBtn)
      btnBlock.appendChild(noBtn)

      confirmWindow.appendChild(btnBlock)
      yesBtn.onclick = () => {
        this.completedTasks = this.completedTasks as number + 1
        this.openTasks = this.openTasks as number - 1
        confirmWindow.remove()
      }
      noBtn.onclick = () => confirmWindow.remove()
    },
    createWindow (message: string): HTMLDivElement {
      const confirmWindow = document.createElement('div')
      confirmWindow.classList.add('confirmWindowStyles')
      document.body.style.position = 'relative'
      const confirmMessage = this.createConfirmMessage(message)
      confirmWindow.appendChild(confirmMessage)
      document.body.appendChild(confirmWindow)
      return confirmWindow
    },
    createConfirmMessage (message: string): HTMLParagraphElement {
      const confirmMessage = document.createElement('p')
      confirmMessage.classList.add('confirmMessageStyles')
      confirmMessage.innerText = message
      return confirmMessage
    },
    createButton (btnName: string): HTMLButtonElement {
      const btn = document.createElement('button')
      btn.innerHTML = btnName
      btn.classList.add('btnStyles')
      return btn
    },
    createBtnBlock (): HTMLDivElement {
      const btnBlock = document.createElement('div')
      btnBlock.classList.add('btnBlockStyles')
      return btnBlock
    }
  },
  mounted () {
    this.emitter.on('getIndex', (index) => {
      this.notifications = index as number
    })
  }
})
